<template>
	<div>
		<h3 style="display: flex;margin-left: -10px;margin-top: -15px;">
			<div class="blue"></div>现金红包详情
		</h3>
		<div>
			<el-form label-width="100px" label-position="left">
				<h4>基本设置</h4>
				<el-form-item label="活动名称">
					<el-input v-model="sendData.actName" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="红包金额">
					<el-input type="number" v-model="sendData.totalAmount" :min="0.01" size="small"
						style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="场景">
					<el-select v-model="sendData.sceneId">
						<el-option v-for="(item,key) in sceneList" :key="key" :value="item.id"
							:label="item.name"></el-option>
					</el-select>
				</el-form-item>
				<h4>内容设置</h4>
				<el-form-item label="祝福语">
					<el-input v-model="sendData.wishing" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="sendData.remark" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="状态">
					<el-switch v-model="sendData.isClose" :active-value="true" active-text="上架" :inactive-value="false"
						inactive-text="下架"></el-switch>
				</el-form-item>
			</el-form>
			<div class="flex" style="padding-left: 150px;">
				<el-button @click="back()">取消</el-button>
				<el-button type="primary" @click="save()">保存</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				sceneList: [{
					id: 'PRODUCT_1',
					name: '商品促销',
				}, {
					id: 'PRODUCT_2',
					name: '抽奖',
				}, {
					id: 'PRODUCT_3',
					name: '虚拟物品兑奖',
				}, {
					id: 'PRODUCT_4',
					name: '企业内部福利',
				}, {
					id: 'PRODUCT_5',
					name: '渠道分润',
				}, {
					id: 'PRODUCT_6',
					name: '保险回馈',
				}, {
					id: 'PRODUCT_7',
					name: '彩票派奖',
				}, {
					id: 'PRODUCT_8',
					name: '税务刮奖',
				}, ],
				sendData: {
					actName: '',
					totalAmount: '',
					sceneId: '',
					wishing: '',
					remark: '',
					isClose: '',
				},
				query: {
					pageNum: 1,
					pageSize: 20,
				}
			}
		},
		mounted() {
			if (this.$route.query.id != null) {
				this.getDetail()
			}
		},
		methods: {
			getDetail() {
				this.$http.get("dRedpackSetting/list" + "?id=" + this.$route.query.id + "&pageNum=" + this.query.pageNum +
					"&pageSize=" + this.query.pageSize).then(res => {
					this.sendData = res.body.data[0]
					this.sendData.totalAmount = this.sendData.totalAmount / 100
					console.log(res)
				})
			},
			save() {
				this.sendData.totalAmount *= 100
				this.$http.post("dRedpackSetting/save", JSON.stringify(this.sendData)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						this.$router.push("redPack")
					}
				})
			},
			back() {
				this.$router.go(-1)
			}
		}
	}
</script>

<style>
	.flex {
		display: flex;
	}

	.blue {
		width: 5px;
		height: 15px;
		background: #409EFF;
		border-radius: 2px;
		margin-right: 8px;
		position: relative;
		top: 4px;
	}

	.abutton {
		color: #999;
		border: 2px dashed;
		width: 50px;
		margin-left: 10px;
	}

	.title {
		margin-top: -10px;
	}

	.stitle {
		flex: 1;
		font-size: 18px;
	}
</style>